import {
  AfterContentInit,
  AfterViewChecked,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import {InsparkTemplate} from '@inspark/inspark-components';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'in-standard-group-form-builder',
  templateUrl: './standard-group-form-builder.component.html',
  styleUrls: ['./standard-group-form-builder.component.scss']
})
export class StandardGroupFormBuilderComponent implements OnInit, OnDestroy, OnChanges, AfterViewChecked, AfterContentInit {
  @Input() isOneColumn = false;
  @Input() meta: StandardFormMetaInfo[];
  @Input() isCustomContent = false;
  @Input() values = {};
  @Input() itemOptions = {};
  @Input() labels: string[];
  @Input() buttons;
  @Input() buttonsLabels;
  @Input() countLabels;
  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @ContentChildren(InsparkTemplate) templates: QueryList<InsparkTemplate>;
  @ViewChild('tooltips', {static: true}) tooltips: ElementRef<any>;

  @Input() activated?: { [key: string]: boolean } = {};
  @Input() disabled? = {save: true, create: false};
  bodyTemplate: TemplateRef<any>;
  valueTemplate: TemplateRef<any>;
  emptyOption = {
    label: null,
    value: null
  };
  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
    return;
  }

  ngOnDestroy() {
    return;
  }

  ngOnChanges() {
    return;
  }
  ngAfterViewChecked() {
    if (this.tooltips.nativeElement.children.length > 0) {
      const [t1, t2] = this.tooltips.nativeElement.children;

      const t1HasChildren = !!t1 && t1.children.length > 0;
      const t2HasChildren = !!t2 && t2.children.length > 0;

      if (!t1HasChildren && !t2HasChildren) {
        this.buttons = {...this.buttons, menu: false};
      } else {
        this.buttons = {...this.buttons, menu: true};
      }
    }
  }

  onSave() {
    const result = {};
    Object.keys(this.activated).forEach(_key => {
      const m = this.meta.filter(_meta => _meta.field === _key)[0];
      if (this.activated[_key] === true) {
        if (!this.values[_key] && m.type === 'bool') {
          this.values[_key] = false;
        } else if (!this.values[_key]) {
          this.values[_key] = null;
        }
      }
      result[_key] = this.activated[_key] ? this.values[_key] : undefined;
    });
    this.save.next(result);
  }

  onCreate() {
    this.create.next(this.values);
  }

  onActivatedChange(field: string, value: boolean) {
    for(var prop in this.activated) {
      if (this.activated[prop] === true) {
        this.disabled.save = false;
        return;
      }
    }
    this.disabled.save = true;
  }

  checkRequired(fieldName) {

    this.activated[fieldName] = true;
    this.disabled.save = false;
    this.disabled.create = false;

    /*
        return;
        if (this.meta.find(_meta => _meta.required && !this.values[_meta.field])) {
          this.disabled.save = true;
          this.disabled.create = true;
          return;
        }
        this.disabled.save = false;
        this.disabled.create = false;
    */

  }

  /**
   * Транcформирует значение поля в null, если ничего не выбрано для in-dropdown.
   *
   * @param val - текущее значение in-dropdown из $event
   * @param fieldName - названия поля в объекте value
   */
  transformEmpty(val, fieldName) {
    if ( val.isEmpty ) {
      this.values[fieldName] = null;
    }
  }

  compareById(a, b) {
    if (a && b && !(a.id || b.id)) {
      return a && b && a === b;
    }
    return a && b && a.id === b.id;
  }

  compareByValue(a, b) {
    return a && b && a === b;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterContentInit() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'body':
          this.bodyTemplate = item.template;
          break;
        case 'value':
          this.valueTemplate = item.template;
          break;

      }
    });
  }
}
